document.addEventListener("DOMContentLoaded", function() {

  const slider = document.querySelector(".premium-coupon-slider");

  if (!slider) return;

  let scrollAmount = 0;

  setInterval(() => {

    const cardWidth = slider.querySelector(".premium-coupon-card")?.offsetWidth || 280;

    scrollAmount += cardWidth + 12;

    if(scrollAmount >= slider.scrollWidth - slider.clientWidth){
      scrollAmount = 0;
    }

    slider.scrollTo({
      left: scrollAmount,
      behavior: "smooth"
    });

  }, 3000);

});